import { useState } from 'react';

// Placeholder data
const mockOrders = [
  { id: '1', user: 'Juan Pérez', product: 'iPhone 15 Case', status: 'processing', quantity: 2, amount: 51.98, created_at: '2024-03-15' },
  { id: '2', user: 'María García', product: 'AirPods Pro', status: 'purchased', quantity: 1, amount: 249.00, created_at: '2024-03-14' },
  { id: '3', user: 'Carlos López', product: 'Samsung Charger', status: 'shipped_intl', quantity: 1, amount: 35.50, created_at: '2024-03-13' },
  { id: '4', user: 'Ana Martínez', product: 'Kindle Paperwhite', status: 'completed', quantity: 1, amount: 139.99, created_at: '2024-03-10' },
  { id: '5', user: 'Pedro Ruiz', product: 'Laptop Stand', status: 'cancelled', quantity: 1, amount: 45.00, created_at: '2024-03-08' },
];

const statusColors: Record<string, string> = {
  draft: 'bg-gray-100 text-gray-800',
  pending_payment: 'bg-yellow-100 text-yellow-800',
  processing: 'bg-blue-100 text-blue-800',
  purchased: 'bg-indigo-100 text-indigo-800',
  shipped_intl: 'bg-purple-100 text-purple-800',
  received_intl: 'bg-pink-100 text-pink-800',
  shipped_national: 'bg-orange-100 text-orange-800',
  received_national: 'bg-amber-100 text-amber-800',
  delivering: 'bg-teal-100 text-teal-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

const statusLabels: Record<string, string> = {
  draft: 'Borrador',
  pending_payment: 'Pendiente de Pago',
  processing: 'Procesando',
  purchased: 'Comprado',
  shipped_intl: 'Enviado Int.',
  received_intl: 'Recibido Int.',
  shipped_national: 'Enviado Nac.',
  received_national: 'Recibido Nac.',
  delivering: 'En Entrega',
  completed: 'Completado',
  cancelled: 'Cancelado',
};

export default function Orders() {
  const [orders, setOrders] = useState(mockOrders);
  const [filterStatus, setFilterStatus] = useState<string>('');
  const [searchTerm, setSearchTerm] = useState('');

  const filteredOrders = orders.filter((order) => {
    const matchesStatus = !filterStatus || order.status === filterStatus;
    const matchesSearch = !searchTerm ||
      order.user.toLowerCase().includes(searchTerm.toLowerCase()) ||
      order.product.toLowerCase().includes(searchTerm.toLowerCase());
    return matchesStatus && matchesSearch;
  });

  const handleStatusChange = (orderId: string, newStatus: string) => {
    setOrders(orders.map((o) => (o.id === orderId ? { ...o, status: newStatus } : o)));
    // TODO: Call API to update status
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-2xl font-bold text-gray-800">Pedidos</h1>
        <div className="flex gap-4">
          <input
            type="text"
            placeholder="Buscar..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          />
          <select
            value={filterStatus}
            onChange={(e) => setFilterStatus(e.target.value)}
            className="px-4 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
          >
            <option value="">Todos los estados</option>
            {Object.keys(statusLabels).map((status) => (
              <option key={status} value={status}>
                {statusLabels[status]}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Usuario</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Producto</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Estado</th>
                <th className="px-4 py-3 text-center text-sm font-medium text-gray-500">Cant.</th>
                <th className="px-4 py-3 text-right text-sm font-medium text-gray-500">Monto</th>
                <th className="px-4 py-3 text-left text-sm font-medium text-gray-500">Fecha</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {filteredOrders.map((order) => (
                <tr key={order.id} className="hover:bg-gray-50">
                  <td className="px-4 py-3 text-sm font-medium">{order.user}</td>
                  <td className="px-4 py-3 text-sm">{order.product}</td>
                  <td className="px-4 py-3">
                    <select
                      value={order.status}
                      onChange={(e) => handleStatusChange(order.id, e.target.value)}
                      className={`px-2 py-1 rounded text-xs border-0 focus:outline-none focus:ring-2 focus:ring-blue-500 ${statusColors[order.status] || 'bg-gray-100'}`}
                    >
                      {Object.keys(statusLabels).map((status) => (
                        <option key={status} value={status}>
                          {statusLabels[status]}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td className="px-4 py-3 text-sm text-center">{order.quantity}</td>
                  <td className="px-4 py-3 text-sm text-right">${order.amount.toFixed(2)}</td>
                  <td className="px-4 py-3 text-sm text-gray-500">
                    {new Date(order.created_at).toLocaleDateString()}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}